import React from 'react';
import { Link } from 'react-router-dom';
import { FaDiscord, FaTwitter } from 'react-icons/fa';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToFAQ = (e) => {
    e.preventDefault();
    const faqSection = document.getElementById('faq');
    if (faqSection) {
      faqSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <Link to="/" className="footer-logo">
              <img src="/logo.png" alt="RiftOne Cheats" className="footer-logo-img" />
            </Link>
            <p className="footer-description">
              Premium gaming tools. Instant delivery. Undetected performance.
            </p>
          </div>

          <div className="footer-section">
            <h4>Products</h4>
            <ul className="footer-links">
              <li><Link to="/products">All Cheats</Link></li>
              <li><Link to="/status">Status</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Support</h4>
            <ul className="footer-links">
              <li><a href="#faq" onClick={scrollToFAQ}>FAQ</a></li>
              <li><a href="https://discord.gg/riftone" target="_blank" rel="noopener noreferrer">Discord</a></li>
              <li><a href="https://discord.gg/riftone" target="_blank" rel="noopener noreferrer">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <ul className="footer-links">
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><a href="#faq" onClick={scrollToFAQ}>Refund Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} RiftOne. All rights reserved.</p>
          <div className="footer-socials">
            <a href="https://discord.gg/riftone" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Discord">
              <FaDiscord />
            </a>
            <a href="#twitter" className="social-link" aria-label="Twitter">
              <FaTwitter />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
